/* eslint no-param-reassign: "off", no-console: "off" */

const apiStore = {
  state: {
    info: null,
    docsJson: null,
    docsLoading: false,
    schemas: null,
    paths: null
  },
  mutations: {
    getApiDocsJson(state, payload) {
      console.log('[getApiDocsJson] payload: ', payload);
      state.docsJson = payload;
      state.schemas = payload.components.schemas;
      state.paths = payload.paths;
      state.info = payload.info;
      if (payload.servers.length) state.info.url = payload.servers[0].url;
      state.docsLoading = false;
    }
  },
  actions: {
    async getApiDocsJson({ state, commit }) {
      state.docsLoading = true;
      try {
        const resp = await fetch('/apidocs/apidocs.json');
        // check for error
        if (!resp.ok) throw new Error(await resp.text());
        const data = await resp.json();
        commit('getApiDocsJson', data);
        return true;
      } catch (ex) {
        console.error('Error fetching docs json.');
        state.docsLoading = false;
        return false;
      }
    }
  },
  getters: {
      
  }
}
export default apiStore;
